import { apiService } from '@/services/APIService';

const GET_PATH = (expertiseId) => `/expertises/${expertiseId}/comment`;

export default {
  // from CRUD

  getAll(expertiseId, params) {
    return apiService.get(GET_PATH(expertiseId), params);
  },

  get(expertiseId, id, params) {
    return apiService.get(`${GET_PATH(expertiseId)}/${id}`, params);
  },

  create(expertiseId, payload) {
    return apiService.post(GET_PATH(expertiseId), payload);
  },

  update(expertiseId, id, payload) {
    return apiService.put(`${GET_PATH(expertiseId)}/${id}`, payload);
  },

  delete(expertiseId, id) {
    return apiService.delete(`${GET_PATH(expertiseId)}/${id}`);
  },

  deleteAll(expertiseId, payload) {
    return apiService.delete(GET_PATH(expertiseId), payload);
  },
};
